import { InstagramIcon, LinkedinIcon, TelegramIcon } from "./IconsSvg";
import { SocialWrapper } from "styles/jss/Navigation.styles";
import XIcon from "./IconsSvg/XIcon";

export default function SocialSection({ socialLinks }) {
  return (
    <SocialWrapper>
      {socialLinks?.map(link => {
        const social =
          link.social === "instagram" ? (
            <InstagramIcon />
          ) : link.social === "telegram" ? (
            <TelegramIcon />
          ) : link.social === "linkedin" ? (
            <LinkedinIcon />
          ) : link.social === "X" ? (
            <XIcon />
          ) : null;

        return (
          <a
            href={link.url}
            key={link.social}
            target={"_blank"}
            rel={"noreferrer"}
            aria-label={link.social}
          >
            {social}
          </a>
        );
      })}
    </SocialWrapper>
  );
}
